import { createFileRoute, Outlet } from '@tanstack/react-router';

/**
 * Layout-Route fuer /artikel. Reine Wrapper-Komponente — Listen-Inhalt liegt in
 * artikel.index.tsx, Detail-/Form-Routen (artikel.$id.tsx, artikel.neu.tsx) werden ueber
 * den Outlet hier gerendert.
 *
 * Vorher hatte artikel.tsx selbst die Listen-Komponente — TanStack file-based
 * Routing hat sie aber als Parent fuer die Child-Routen erkannt. Ohne Outlet
 * sind Children nie gerendert; Klick auf "/artikel/neu" zeigte still die Liste.
 */
export const Route = createFileRoute('/artikel')({
  component: ArtikelLayout,
});

function ArtikelLayout() {
  return <Outlet />;
}
